import { render } from "./DataGrid.vue?vue&type=template&id=645b1f36&scoped=true&ts=true"
import script from "./DataGrid.vue?vue&type=script&lang=ts"
export * from "./DataGrid.vue?vue&type=script&lang=ts"

import "./DataGrid.vue?vue&type=style&index=0&id=645b1f36&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645b1f36"]])

export default __exports__